import { ReactNode } from 'react'

import { Flex } from './Flex'
import { HoverCard } from './HoverCard'
import { Icon, IconName } from './Icon'
import { Link } from './Link'
import { Text } from './Text'
import { Color } from '../constants'

type DetailProps = {
  bold?: boolean
  ellipsis?: boolean
  icon: IconName
  iconColor?: Color
  label: string | ReactNode
  labelColor?: Color
  solidIcon?: boolean
  compact?: boolean
  to?: string
  hoverCard?: ReactNode
}

export const Detail = (props: DetailProps) => {
  const detail = (
    <Flex
      gap={props.compact ? 2 : 3}
      items="center"
      styles={{ flexShrink: '1', overflow: 'hidden' }}
    >
      <Icon
        color={props.iconColor ?? Color.DARKER_GREY}
        design={props.solidIcon ? 'solid' : 'outline'}
        name={props.icon}
        size="sm"
      />
      {typeof props.label === 'string' ? (
        <Text
          fontSize={14}
          bold={props.bold}
          color={props.labelColor ?? Color.DARKER_GREY}
          styles={{
            whiteSpace: props.ellipsis ? 'nowrap' : 'normal',
            overflow: props.ellipsis ? 'hidden' : 'visible',
            textOverflow: props.ellipsis ? 'ellipsis' : 'clip',
          }}
        >
          {props.label}
        </Text>
      ) : (
        props.label
      )}
    </Flex>
  )

  if (props.hoverCard) {
    return (
      <HoverCard
        arrow={false}
        side="bottom"
        sideOffset={-50}
        trigger={
          <Flex gap={2}>
            {detail}
            <Icon
              size="sm"
              name="InformationCircleIcon"
              color={props.labelColor ?? Color.BLUE}
            />
          </Flex>
        }
      >
        {props.hoverCard}
      </HoverCard>
    )
  }

  if (props.to) {
    return (
      <Link to={props.to} styles={{ width: '100%', display: 'block' }}>
        <Flex gap={2}>
          {detail}
          <Icon size="sm" name="ExternalLinkIcon" color={Color.BLUE} />
        </Flex>
      </Link>
    )
  }

  return detail
}
